import React from 'react';
import { Box, Button } from 'pcln-design-system';
const TripProtectionMarker = () => {
  return React.createElement(Box, {
    ml: 3,
    mb: 4
  }, React.createElement(Button, {
    width: 1,
    size: 'small'
  }, "Add Trip Protection"));
};
export default TripProtectionMarker;